/**
 * Bază URL API (fără slash final).
 * Override local: `.env.local` → `REACT_APP_API_URL=http://localhost:3001`
 */
export const PROMOTION_API_BASE = (
  process.env.REACT_APP_API_URL || 'https://api-backend.brain-event.com'
).replace(/\/$/, '');
